<template>
  <div id="app">
    <div
      id="ReminderBox"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ReminderBox"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="lbl_ReminderTitle" class="modal-title">
              {{ $t("Reminder") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div id="lbl_ReminderContent" class="modal-body">
            <div class="form-row">
              <div class="form-group col">
                {{ errormessage }}
              </div>
            </div>

            <div class="form-row">
              <button
                class="btn btn-primary col-md-8"
                @click="onReminderCancel()"
                style="margin: auto"
              >
                {{ $t("Back") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <canvas id="load" ref="load"></canvas>
    <div class="main-wrapper container">
      <Navbar iconAction="1" :changeurl="changeurl()"></Navbar>

      <nav
        class="navbar navbar-secondary"
        style="background-color: #fafdfb; box-shadow: 0 0px 0px rgb(0 0 0 / 0%)"
      >
        <div class="container">
          <h3>{{ $t("Confirm to bind with K Dollar Program") }}</h3>
        </div>
      </nav>

      <!-- Main Content -->
      <div class="main-content">
        <section class="section">
          <div class="section-body">
            <div class="card col-md-6" style="margin: auto">
              <div class="card-body">
                <div class="form-row">
                  <p>
                    {{
                      $t(
                        "Please note that your existing KLUB points will be converted as K points after binding with your registered KDP Account"
                      )
                    }}
                  </p>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <font style="color: #c8b28b"
                      ><b> {{ $t("KDP MEMBER NUMBER") }} </b></font
                    >
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    {{ kdpmembernumber }}
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-12">
                    <font style="color: #c8b28b"
                      ><b>
                        {{ $t("FIRST NAME") }} ({{
                          $t("SAME WITH HKID/PASSPORT")
                        }})
                      </b></font
                    >
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    {{ first_name }}
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-12">
                    <font style="color: #c8b28b"
                      ><b>
                        {{ $t("LAST NAME") }} ({{
                          $t("SAME WITH HKID/PASSPORT")
                        }})
                      </b></font
                    >
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    {{ last_name }}
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <font style="color: #c8b28b"
                      ><b> {{ $t("EMAIL") }} </b></font
                    >
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    {{ email }}
                  </div>
                </div>

                <button
                  class="btn btn-primary col-md-12"
                  id="sumbit"
                  ref="sumbit"
                  @click="bind()"
                  :disabled="!agreement_1 || !loaded"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    style="margin-right: 5px"
                    id="spin"
                    role="status"
                    aria-hidden="true"
                    ref="spin"
                    v-if="spinner"
                  >
                  </span>
                  <span id="loading" ref="loading">{{
                    $t("I agree to bind")
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<style>
canvas {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  box-sizing: border-box;
  margin: 0;
  width: 100%;
  height: 100%;
}

.vue-country-select .current .country-code {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
<script>
import api from "@/api";
import { mapActions, mapGetters, mapMutations } from "vuex";
import helper from "@/vueHelper";
import config from "@/config";
import Navbar from "@/components/Navbar.vue";

export default {
  components: { Navbar },
  data() {
    return {
      errormessage: "",
      k11vipcode: null,
      k11accountno: null,
      kdpmembernumber: null,
      agreement_1: false,
      spinner: false,
      first_name: null,
      last_name: null,
      email: null,
      curbonus: 0,
      loaded: false,
      callbackurl: null,
      phone: null,
      country_code: null,
      session: null,
      backtohome: false,
    };
  },
  created() {
    this.actionSetForceBlock(false);
    this.callbackurl = window.sessionStorage.getItem("callbackurl");
    this.k11vipcode = window.sessionStorage.getItem("k11vipcode");
    this.k11accountno = window.sessionStorage.getItem("k11accountno");
    this.kdpmembernumber = window.sessionStorage.getItem("kdpmembernumber");
    this.phone = window.sessionStorage.getItem("phone");
    this.country_code = window.sessionStorage.getItem("country_code");
    this.session = window.sessionStorage.getItem("session");
    window.sessionStorage.clear();
    if (this.k11vipcode == null || this.kdpmembernumber == null) {
      window.location.href = "./#/";
    }
    helper.loading();
    api.request(
      this,
      "post",
      "/migrationhub/member/profile",
      {
        kdp_search_value: this.kdpmembernumber,
        phone: this.phone,
        country_code: this.country_code,
        SESSION: this.session,
      },
      function (r) {
        if (r.success) {
          this.first_name = r.data.kdp["name"]["en"]["first_name"];
          this.last_name = r.data.kdp["name"]["en"]["last_name"];
          this.email = r.data.kdp["email"];
          let vm = this;
          let check_k11vipcode = this.k11vipcode.substring(0, 2);
          if (this.k11vipcode.length == 16 && check_k11vipcode != "01") {
            vm.curbonus = 0;
            vm.loaded = true;
            vm.agreement_1 = true;
          } else {
            $.ajax({
              method: "POST",
              contentType: "application/json",
              url: config.serverURI + "/migrationhub/point/balance",
              data: JSON.stringify({
                k11_member_number: vm.k11accountno,
                kdp_member_number: null,
                phone: vm.phone,
                country_code: vm.country_code,
                SESSION: vm.session,
              }),
              complete: function (jdata2) {
                if (jdata2.responseJSON.success) {
                  vm.curbonus = jdata2.responseJSON.data.total_point_balance;
                  vm.loaded = true;
                  vm.agreement_1 = true;
                } else {
                  if (jdata2.responseJSON.errorcode == "K2013") {
                    vm.errormessage =
                      jdata2.responseJSON.msg[
                        helper.getMappingLocale(vm.$i18n.locale)
                      ];
                    vm.backtohome = true;
                  } else {
                    vm.errormessage =
                      vm.$t("Something went wrong") +
                      " (" +
                      jdata2.responseJSON.msg[
                        helper.getMappingLocale(vm.$i18n.locale)
                      ] +
                      ")";
                  }
                  $("#ReminderBox").modal("show");
                }
              },
            });
          }
          helper.done();
        } else {
          helper.done();
          if (r.errorcode == "K2013") {
            this.errormessage =
              r.msg[helper.getMappingLocale(this.$i18n.locale)];
            this.backtohome = true;
            $("#ReminderBox").modal("show");
          } else {
            vm.errormessage =
              vm.$t("Something went wrong") +
              " (" +
              r.msg[helper.getMappingLocale(vm.$i18n.locale)] +
              ")";
            $("#ReminderBox").modal("show");
          }
        }
      },
      function (r) {},
      false,
      null
    );
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),
    ...mapGetters(["getIsBlock", "isWechat", "getPipl"]),
  },
  mounted() {
    this.$store.dispatch('actionRetrieveWechatRelatedParams')
    console.log("isWeChat-bind", this.isWechat)
    if (this.isWechat) {
      this.agreement_1 = true
    }
  },
  methods: {
    ...mapMutations(["setIsWechat"]),
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest",
      "actionRetrieveWechatRelatedParams"
    ]),
    ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock"]),
    onReminderCancel() {
      $("#ReminderBox").modal("hide");
      if (this.backtohome) {
        window.sessionStorage.setItem("callbackurl", this.callbackurl);
        window.location.href = "./#/";
      }
    },
    changeurl() {
      window.sessionStorage.setItem("callbackurl", this.callbackurl);
    },
    bind() {
      let vm = this;
      $(this.$refs.load).css("z-index", "2147483647");

      $(this.$refs.loading)[0].innerText = this.$t("Loading") + "...";
      vm.spinner = true;

      const bindingData = {
        k11_member_number: vm.k11vipcode,
        kdp_member_number: vm.kdpmembernumber,
        phone: vm.phone,
        country_code: vm.country_code,
        SESSION: vm.session,
      }

      const storeData = this.$store.state
      if (this.isWechat && storeData.unionId != "") {
        bindingData.MARKETING_OPT_IN = parseInt(storeData.kdp_optin)
        bindingData.ISAGREE_KLUB11_OPT_IN = storeData.k11_optin
        bindingData.ISAGREE_KLUB11_AFFILIATES_OPT_IN = storeData.k11_aff_optin
        bindingData.ISAGREE_KDP_AFFILIATES_OPT_IN = storeData.kdp_aff_optin
        bindingData.union_id = storeData.unionId
        bindingData.openId = storeData.openId
        bindingData.openType = storeData.openType
        bindingData.pipl = this.getPipl("pipl")
        console.log(bindingData)
      }

      $.ajax({
        method: "POST",
        contentType: "application/json",
        url: config.serverURI + "/migrationhub/member/binding",
        data: JSON.stringify(bindingData),
        complete: function (jdata) {
          if (jdata.responseJSON.success) {
            window.sessionStorage.setItem("email", vm.email);
            window.sessionStorage.setItem("curbonus", vm.curbonus);
            window.sessionStorage.setItem("binding", "1");
            $(vm.$refs.load).css("z-index", 0);
            vm.changeurl();
            window.location.href = "./#/kdpsuccess";
          } else {
            if (jdata.responseJSON.errorcode == "K2013") {
              vm.errormessage =
                jdata.responseJSON.msg[
                  helper.getMappingLocale(vm.$i18n.locale)
                ];
              vm.backtohome = true;
              $("#ReminderBox").modal("show");
            } else {
              vm.errormessage =
                vm.$t("Something went wrong") +
                " " +
                jdata.responseJSON.msg[
                  helper.getMappingLocale(vm.$i18n.locale)
                ] +
                " (" +
                jdata.responseJSON.errorcode +
                ")";
              $("#ReminderBox").modal("show");
            }
            vm.spinner = false;
            $(vm.$refs.loading)[0].innerText = vm.$t("I agree to bind");
            $(vm.$refs.load).css("z-index", 0);
          }
        },
      });
    },
  },
};
</script>
